const styles = (theme) => ({
  phoneIcon: {
    fontSize: '2rem',
  },
  callButton: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    padding: 11,
    backgroundColor: theme.palette.primary.dark,
    color: `${theme.palette.text.white} !important`,
  },
});

export default styles;
